import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Trans, t } from '@lingui/macro'

import IconInfo from '../../../../components/common/icon/IconInfo'
import { IOrganisation } from '../../types'
import { Checkbox } from '../../../../components/common/form/checkbox/Checkbox'
import validators from '../../../../../../shared/validations'
import { notification } from '../../../../components/common/notifications/Notifications'
import { AccessibilityLabel } from '../../../../components/common/AccessibilityLabel'

import './DomainLockConfig.less'

@observer
class DomainLockConfig extends Component<{
  organisation: Pick<IOrganisation, 'domainWhitelistBreaches' | 'domain_lock'>
  onDomainWhitelistChange: (domains: string[]) => void
}> {
  @observable
  enabled = false
  @observable
  dirty = false
  @observable
  badSeperator = false
  @observable
  whiteListText = ''
  @observable
  whitelistBreaches: IOrganisation['domainWhitelistBreaches'] | null = null

  init(props) {
    if (props.organisation.domain_lock) {
      this.enabled = true
      this.whiteListText = props.organisation.domain_lock.join(', ')
      this.whitelistBreaches = props.organisation.domainWhitelistBreaches
    }
  }

  async UNSAFE_componentWillMount() {
    await this.init(this.props)
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    await this.init(nextProps)
  }

  render() {
    const { organisation } = this.props

    return (
      <div>
        <div className="form-row">
          <h4>
            <Trans>Domain allowlist</Trans>
          </h4>
          <p className="text-description">
            <Trans>
              The domain allowlist controls who can be added to your account.
              New users must have an email address on an allowed domain in order
              to access your Looop site. Enter domains ('your-domain.com')
              separated by commas.
            </Trans>
          </p>
        </div>
        <div className="form-row">
          <div className="AccountPage__checkBoxWrapper">
            <Checkbox
              id="useDomainWhitelist"
              isChecked={this.enabled}
              onChange={(ev) => {
                if (organisation.domain_lock === null) {
                  organisation.domain_lock = '' as any as string[] // TODO fix this to always use an array of strings
                }
                this.enabled = ev.target.checked
                this.dirty = true
                if (!this.enabled) {
                  this.whitelistBreaches = null
                }
              }}
            >
              <Trans>Use domain allowlist</Trans>
            </Checkbox>{' '}
          </div>
        </div>
        {this.enabled ? (
          <div className="form-row">
            <AccessibilityLabel text="allowlist">
              <textarea
                className="form-textAreaInput"
                style={{
                  borderColor: this.badSeperator ? '#ef6969' : ''
                }}
                placeholder="mydomain.com, myseconddomain.com"
                value={this.whiteListText}
                onChange={(ev) => {
                  this.whiteListText = ev.target.value
                    .toLowerCase() // domain names can only be lowercase
                    .replace('@', '') // see DEV-863
                  this.dirty = true

                  const whitespaceSeperatorsRegex = /\w\s+?\w/
                  if (this.whiteListText.match(whitespaceSeperatorsRegex)) {
                    this.badSeperator = true
                  } else {
                    const badSeperators = [';', '|', ':', '\n']
                    for (const char of badSeperators) {
                      if (this.whiteListText.includes(char)) {
                        this.badSeperator = true
                        return
                      }
                    }
                    this.badSeperator = false
                  }
                }}
              />
            </AccessibilityLabel>

            {this.badSeperator && (
              <div
                style={{
                  position: 'relative',
                  top: -5
                }}
                className="form-rowWarning"
              >
                <IconInfo />
                <Trans>Whitelist entries must be separated by commas</Trans>
              </div>
            )}
          </div>
        ) : null}
        <div className="form-row">
          <button
            className="btn btn-info"
            disabled={this.badSeperator}
            style={{
              display: this.dirty ? 'block' : 'none'
            }}
            onClick={async () => {
              const { onDomainWhitelistChange } = this.props
              if (this.enabled) {
                const domains = this.whiteListText
                  .split(',')
                  .map((domain) => domain.trim())

                const invalidDomains = domains.filter(
                  (d) => !d.match(validators.domain)
                )

                if (invalidDomains.length > 0) {
                  notification.error(
                    t`Invalid domains: ${invalidDomains.join(', ')}`
                  )
                } else {
                  onDomainWhitelistChange(domains)
                }
              } else {
                // @ts-expect-error 9/11/2020
                onDomainWhitelistChange(null)
              }

              this.dirty = false
            }}
          >
            {this.enabled ? t`Update allowlist` : t`Save`}
          </button>
        </div>
        {this.whitelistBreaches &&
        Object.keys(this.whitelistBreaches).length ? (
          <div className="form-row">
            <p
              className="text-description"
              data-test="DescriptionForAllowlistBreach"
            >
              <br />
              <Trans>
                Your account contains users from domains outside of this
                allowlist.
                <br />
                These domains are:
              </Trans>
            </p>
            <ul>
              {Object.keys(this.whitelistBreaches).map((domain) => {
                // @ts-expect-error 9/11/2020
                const domainBreaches = this.whitelistBreaches[domain]

                return (
                  <li key={domain}>
                    @{domain} ({domainBreaches.length})
                  </li>
                )
              })}
            </ul>
          </div>
        ) : null}
      </div>
    )
  }
}

export default DomainLockConfig
